module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), (_vm.job !== null) ? _c('v-toolbar-title', {
    domProps: {
      "innerHTML": _vm._s(this.job.vehicle !== undefined ? 'Vehicle: ' + this.job.vehicle : 'Vehicle: ' + this.job.reg)
    }
  }) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.role !== 'Supplier') ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.jobState === 2 || _vm.jobState === 1) ? _c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.approveJob
          }
        }, on), [_c('v-icon', [_vm._v("done")])], 1) : _vm._e()]
      }
    }], null, false, 1292651899)
  }, [_vm._v(" "), _c('span', [_vm._v("The Gary Day Button")])]) : _vm._e(), _vm._v(" "), (_vm.role !== 'Supplier') ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.jobState > 1) ? _c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.flagJobIssue
          }
        }, on), [_c('v-icon', [_vm._v("warning")])], 1) : _vm._e()]
      }
    }], null, false, 2102614263)
  }, [_vm._v(" "), _c('span', [_vm._v("Flag Issue With Job")])]) : _vm._e(), _vm._v(" "), (_vm.role !== 'Supplier') ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.fixBrokenImage
    }
  }, [_c('v-icon', [_vm._v("mdi-image-broken-variant")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.print
    }
  }, [_c('v-icon', [_vm._v("print")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.show
    }
  }, [_c('v-icon', [_vm._v("view_carousel")])], 1)], 1), _vm._v(" "), (_vm.fetchingJob) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    staticClass: "mt-5",
    attrs: {
      "size": 70,
      "width": 7,
      "color": "primary",
      "indeterminate": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.attachedDocs) ? _c('div', {
    staticClass: "blue lighten-5 px-5"
  }, [_c('h5', [_vm._v("Job Attachments")]), _vm._v(" "), _vm._l((_vm.attachedDocs), function(doc) {
    return _c('v-list-tile', {
      key: doc.name
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("mdi-file-document-outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('a', {
      attrs: {
        "href": doc.downloadUrl,
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(doc.name))])])], 1)], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.job !== null) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.job.startTime) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('strong', [_c('v-icon', [_vm._v("mdi-flag")]), _vm._v(" Start Time:")], 1), _vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.job.startTime)) + "\n          "), _c('strong', [_c('v-icon', [_vm._v("mdi-flag-checkered")]), _vm._v(" End Time:")], 1), _vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.job.endTime)) + "\n          "), _c('strong', [_c('v-icon', [_vm._v("mdi-clock")]), _vm._v(" Total:")], 1), _vm._v(" " + _vm._s(_vm._f("milisecondToMinutes")((_vm.job.endTime - _vm.job.startTime))) + "\n          "), (_vm.job.notes) ? _c('h4', [_vm._v("General Job Notes")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.job.notes))])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, _vm._l((_vm.job.template), function(temp, index) {
    return _c('v-expansion-panel', {
      key: index,
      attrs: {
        "dark": ""
      }
    }, [_c('v-expansion-panel-content', [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('strong', [_vm._v(_vm._s(temp.name))])]), _vm._v(" "), _vm._l((temp.items), function(item, ni) {
      return _c('v-card', {
        key: ni
      }, [_c('v-list', [_c('v-list-tile', {
        class: item.image.length > 0 || item.note.length > 0 ? 'green--text' : 'grey--text',
        on: {
          "click": function($event) {
            return _vm.loadImage(item, index, ni)
          }
        }
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.text))])], 1)], 1)], 1)], 1)
    })], 2)], 1)
  }), 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": "",
      "text-xs-center": ""
    }
  }, [(_vm.currentNote !== '') ? _c('p', [_vm._v(_vm._s(_vm.currentNote))]) : _vm._e(), _vm._v(" "), (_vm.currentImage !== '') ? _c('img', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "src": _vm.currentImage
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "viewer",
      rawName: "v-viewer",
      value: ({
        title: function (image) { return ("" + (image.alt)); }
      }),
      expression: "{title:(image) => `${image.alt}`}"
    }],
    staticClass: "images clearfix",
    attrs: {
      "hidden": ""
    }
  }, [_vm._l((_vm.images), function(image) {
    return [_c('img', {
      key: image.image,
      staticClass: "image ma-2",
      attrs: {
        "src": image.image,
        "width": "100",
        "alt": image.title
      }
    })]
  })], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.testingDialog),
      callback: function($$v) {
        _vm.testingDialog = $$v
      },
      expression: "testingDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.testingDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Testing")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.testingDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('testing', {
    attrs: {
      "UID": _vm.testsUID,
      "activeTestUID": _vm.activeTest
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-011cb379","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompletedJobViewComponent.vue
// module id = 730
// module chunks = 1